import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Header} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import {downloadFile} from '../../../common/util/file';
import VehiclesTable from './Table';
import './styles.scss';

const {navigateTo, getListWaitHappy, downloadVehicleList, clearDowloadVehicleList} =
  Actions;

const ListVehiclesWaitHappy = () => {
  const dowloadHappyWait = useSelector((state) => state.dowloadHappyWait);
  const waitHappyVehicles = useSelector((state) => state.waitHappyVehicles);
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const {dealerId, permissions} = session;
  const {loading, url} = dowloadHappyWait;

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.ListVehiclesWaitHappy, scopes.See)) {
      dispatch(navigateTo(paths.AccessDenied));
    }

    dispatch(getListWaitHappy(dealerId));
  }, [dispatch]);

  const handleDownloadList = () => {
    dispatch(downloadVehicleList(dealerId));
  };

  useEffect(() => {
    if (url) {
      downloadFile(url);
      dispatch(clearDowloadVehicleList());
    }
  }, [url, dispatch]);
   
  if (loading || waitHappyVehicles.loading) {
    return <Loader />;
  }

  return (
    <div>
      <Card raised fluid>
        <div className='container-vehicles-happy-wait pd'>
          <Header as='h2'>Listado de Reserva Espera Feliz</Header>
          <div className='pointer' onClick={handleDownloadList}>
            <img
              src={`${process.env.PUBLIC_URL}/icons/excel.svg`}
              alt='excel icon'
            />
          </div>
        </div>
      </Card>
      <Card raised fluid>
        <VehiclesTable />
      </Card>
    </div>
  );
};

export default ListVehiclesWaitHappy;
